import { render } from "./Footer.vue?vue&type=template&id=33f99aa7&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"

import "./Footer.vue?vue&type=style&index=0&id=33f99aa7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-33f99aa7"

export default script